import { LogOut, ShieldCheck } from "lucide-react"
import { Link, Outlet } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { useAuth } from "@/hooks/use-auth"
import { initials } from "@/lib/utils"

export function AdminLayout() {
  const { user, signOut } = useAuth()
  return (
    <div className="min-h-screen bg-muted/30">
      <header className="border-b bg-background">
        <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-6">
          <div className="flex items-center gap-3">
            <ShieldCheck className="size-5" />
            <Link to="/admin" className="text-lg font-semibold tracking-tight">
              Hirefy Admin
            </Link>
            <Badge variant="outline">Superuser</Badge>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/dashboard" className="text-sm text-muted-foreground hover:underline">
              Dashboard'a dön
            </Link>
            <div className="grid size-8 place-items-center rounded-full bg-primary text-xs font-medium text-primary-foreground">
              {initials(user?.full_name ?? user?.email)}
            </div>
            <Button size="icon" variant="ghost" aria-label="Çıkış" onClick={() => signOut()}>
              <LogOut className="size-4" />
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl">
        <Outlet />
      </main>
    </div>
  )
}
